<div class="flex gap-md" [class.items-center]="isItemCenter()">
  @let isCreator = !!creator();
  @let creatorName =
    isCreator ? creatorData().name : (creatorData().name | transloco);
  @let sizeData = sizeConfig();

  @if (isCreator) {
    <lib-avatar
      [fullName]="creatorName"
      [img]="creatorData().image?.url || ''"
      [imgDimensions]="sizeData!.imgDimensions"
      borderRadius="rounded-full"
      [size]="sizeData!.size" />
  } @else {
    <lib-system-avatar-icon [iconClass]="sizeData!.systemAvatarSize" />
  }

  <span class="text-neutral-900" [class]="sizeData!.textClasses">
    {{ creatorName }}
  </span>
</div>
